module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-300-fd46dc46efb83ded87739b7d30d5f514.woff";